<script lang="ts">
import SectionApprenti from '@/extend/sections/SectionApprentiExtend.vue';
import Section from '@/framework/base/classes/Section';
import Apprenti from '@/extend/classes/Apprenti';
import SectionApprentiList from '@/generated/sections/SectionApprentiList.vue';
import { storeApprenti } from '@/generated/stores';
import Etablissement from '../classes/Etablissement';
import { FwkSections, RessourceFwkSection } from '@/ressources/globalRessources';
import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    components: {},
    extends: SectionApprentiList,
    props: {
        etablissement: {
            type: Object as PropType<Etablissement>,
            required: true
        }
    },
    data() {
        return {
            selectedApprenti: new Apprenti()
        };
    },
    computed: {
        addLabel(): string {
            return RessourceFwkSection(FwkSections.NEW_APPRENTI).label;
        },
        showSearch(): boolean {
            return false;
        },
        section(): Section {
            const section = new Section();
            section.component = SectionApprenti;
            section.type = 'apprenti';
            section.data = this.selectedApprenti;
            section.ressource = this.ressource;
            section.isAbstract = this.isAbstract;
            return section;
        }
    },
    methods: {
        defaultFilter(): void {
            {
                const columnFilter = new ColumnFilter();
                columnFilter.name = "etablissementId";
                columnFilter.staticFilter = true;
                const choix = new ListChoix();
                choix.value = this.etablissement.id
                columnFilter.filters.push(choix);
                this.activeFilters.push(columnFilter);
            }
        },
        addItem(): void {
            this.selectedApprenti = storeApprenti.createNewApprenti();
            this.selectedApprenti.dateDebut = new Date();
            this.selectedApprenti.dateFin = new Date();
            this.selectedApprenti.etablissementId = this.etablissement.id;
            if (this.isAbstract) {
              this.$emit("openCrud", this.section);
            } else {
              this.dialogOpen = true;
            }
        },
        selectItem(item: unknown): void {
            this.selectedApprenti.fromApprenti(item as Apprenti)
            this.dialogOpen = true;
        },
        updateItem(item: unknown): void {
            this.selectedApprenti.fromApprenti(item as Apprenti)
            this.dialogOpen = true;
        }
    }
})

</script>
